var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconFilter1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 2.054a.751.751 0 0 0-.748-.8H1.5a.75.75 0 0 0-.748.8 11.254 11.254 0 0 0 8.972 10.22v9.875a.75.75 0 0 0 1.23.576l3-2.5a.748.748 0 0 0 .27-.576v-7.375A11.253 11.253 0 0 0 23.2 2.054Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFilter1);
export default __webpack_public_path__ + "static/media/streamline-icon-filter-1.d2ec5d96.svg";
export { ForwardRef as ReactComponent };